import React from "react";
import moment from "moment";
import { fromJS } from "immutable";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import { gql, graphql } from "react-apollo";

const dateFormat = "DD/MM/YYYY";

const CustomizedAxisTick = ({ x, y, stroke, payload }) =>
  <g transform={`translate(${x},${y})`}>
    <text x={0} y={0} dy={16} textAnchor="end" fill="#666">
      {payload.value}h
    </text>
  </g>;

const OrdersByDayBarChart = ({ date, data }) => {
  const orders = fromJS(data.orders);
  if (!orders || !date) return null;
  const mDate = moment(date, dateFormat);

  const formatterGenerator = (hh, h, mm, m) => duration => {
    const d = moment.duration(duration, "minutes");
    const hor = Math.round(d.asHours());
    const horas = hor > 0 ? (hor > 1 ? `${hor}${hh}` : `1${h}`) : "";
    const minutos =
      d.minutes() > 0
        ? d.minutes() > 1 ? `${d.minutes()}${mm}` : `1${m}`
        : "";
    const separator = " ";
    return `${horas}${separator}${minutos}`;
  };
  const formatter = formatterGenerator(
    " horas",
    " hora",
    " minutos",
    " minuto"
  );
  const tickFormatter = formatterGenerator("h", "h", "m", "m");

  const relevantOrders = orders;
  // .filter(o => o.get('delivered'))

  const orderLines = relevantOrders
    .map(o => o.get("orderLines"))
    .flatten(1)
    .filter(ol => ol.get("status") === "DONE")
    .filter(ol => {
      const orderDate = moment(ol.get("statusAt"));
      const result = orderDate.isSame(mDate, "day");
      return result;
    })
    .sort(
      (a, b) =>
        moment(a.get("statusAt")).isBefore(moment(b.get("statusAt"))) ? -1 : 1
    );

  const orderLineTimes = orderLines
    .map(ol => ({
      duration: Math.round(
        moment
          .duration(moment(ol.get("statusAt")).diff(ol.get("createdAt")))
          .asMinutes()
      ),
      statusAt: moment(ol.get("statusAt")).format("H")
    }))
    .toJS();

  return (
    <ResponsiveContainer width="90%" minHeight={250}>
      <ComposedChart
        data={orderLineTimes}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      >
        <XAxis dataKey="statusAt" height={50} tick={<CustomizedAxisTick />} />
        <YAxis tickFormatter={tickFormatter} width={70} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip formatter={formatter} />
        <Legend />
        <Line
          type="monotone"
          dataKey="duration"
          stroke="#8884d8"
          name="Tiempo de producción"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

const Orders = gql`
  query Orders {
    orders {
      id
      delivered
      createdAt
      updatedAt
      orderLines {
        id
        quantity
        unitPrice
        status
        createdAt
        updatedAt
        statusAt
      }
    }
  }
`;

export default graphql(Orders)(OrdersByDayBarChart);



// WEBPACK FOOTER //
// ./src/components/presentational/OrderLineProcessingTimeByDayChart.js